export default {
  PAGINATION: {
    PER_PAGE: 3,
  },
  sortable: true,
};
